import Colyseus from "./colyseus";

export default new Colyseus.Client(process.env.VUE_APP_SERVER_WS_URL);